<rcp-oup-two-col-layout
    headerLabel="Your OneSpot Worklist > Issues"
    icon="fa-regular fa-list-check"
    titleIcon="fa-regular fa-list-check"
    leftMenuClass="min-w-[200px] max-w-[200px]"
    [removeSecondaryHeader]="true">
    <div left-menu>
        <div class="pt-2">
            <a
                class="text-link no-line"
                routerLink="/os-worklist/summary"
                (mouseenter)="isAllWorklistHovered = true"
                (mouseleave)="isAllWorklistHovered = false">
                <span class="pr-2 font-bold"> All Worklist Items </span>
                <i
                    *ngIf="isAllWorklistHovered"
                    class="text-main-red fa-xs fa-sharp fa-solid fa-triangle fa-rotate-90"></i>
            </a>
        </div>
        <mat-nav-list class="p-0 m-0 ml-2">
            <div>
                <a
                    mat-list-item
                    class="text-link no-line"
                    routerLink="/os-worklist/to-do">
                    <i class="fa-solid fa-check-double"></i>
                    <span
                        class="px-2"
                        (mouseenter)="isToDoHovered = true"
                        (mouseleave)="isToDoHovered = false">
                        To-Dos
                    </span>
                    <i
                        *ngIf="isToDoHovered"
                        class="text-main-red fa-xs fa-sharp fa-solid fa-triangle fa-rotate-90"></i>
                </a>
                <a
                    mat-list-item
                    class="text-link no-line"
                    routerLink="/os-worklist/notifications">
                    <i class="fa-solid fa-bell"></i>
                    <span
                        class="px-2"
                        (mouseenter)="isNotificationsHovered = true"
                        (mouseleave)="isNotificationsHovered = false">
                        Notifications
                    </span>
                    <i
                        *ngIf="isNotificationsHovered"
                        class="text-main-red fa-xs fa-sharp fa-solid fa-triangle fa-rotate-90"></i>
                </a>
                <a
                    mat-list-item
                    class="text-link no-line"
                    routerLink="/os-worklist/issues">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <span class="px-2 font-semibold"> Issues </span>
                    <i
                        class="text-main-red fa-xs fa-sharp fa-solid fa-triangle fa-rotate-90"></i>
                </a>
            </div>
        </mat-nav-list>
    </div>
    <div class="flex flex-col h-full w-full">
        <div
            class="flex flex-col h-full justify-center items-center bg-white border border-gray-border mb-12">
            <div
                class="w-full font-bold border-b border-gray-border bg-table-header-bg p-1.5">
                <i class="fa-solid fa-triangle-exclamation pl-1"></i> Issues
            </div>
            <div
                class="flex flex-col h-full justify-center items-center max-w-[450px]">
                <div class="pb-8">
                    <i class="fa-regular fa-5x fa-megaphone text-main-red"></i>
                </div>
                <div class="text-[20px] font-serif italic font-semibold p-4">
                    Coming Soon!
                </div>
                <div class="text-center">
                    The ability to create, view, and manage To-Dos,
                    Notifications, and other Worklist items will launch soon!
                </div>
            </div>
        </div>
    </div>
</rcp-oup-two-col-layout>
